"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileDevice = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var isMobileDevice = function isMobileDevice() {
  return (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object' ? 'ontouchstart' in window : false;
};
exports.isMobileDevice = isMobileDevice;